/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Push_Topicplaceholder1Inputs */

const id_notifications_push_topicplaceholder1 = /** @type {(inputs: Notifications_Push_Topicplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masukkan nama topik (mis., game-updates)`)
};

const ms_notifications_push_topicplaceholder1 = /** @type {(inputs: Notifications_Push_Topicplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masukkan nama topik (cth., game-updates)`)
};

const da_notifications_push_topicplaceholder1 = /** @type {(inputs: Notifications_Push_Topicplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indtast emnenavn (f.eks. game-updates)`)
};

const de_notifications_push_topicplaceholder1 = /** @type {(inputs: Notifications_Push_Topicplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Themennamen eingeben (z.B. game-updates)`)
};

const en_us2_notifications_push_topicplaceholder1 = /** @type {(inputs: Notifications_Push_Topicplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter topic name (e.g., game-updates)`)
};

const es_es2_notifications_push_topicplaceholder1 = /** @type {(inputs: Notifications_Push_Topicplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce el nombre del tema (p. ej., game-updates)`)
};

const es_mx2_notifications_push_topicplaceholder1 = /** @type {(inputs: Notifications_Push_Topicplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa el nombre del tema (p. ej., game-updates)`)
};

const fil_notifications_push_topicplaceholder1 = /** @type {(inputs: Notifications_Push_Topicplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilagay ang pangalan ng paksa (hal., game-updates)`)
};

const fr_notifications_push_topicplaceholder1 = /** @type {(inputs: Notifications_Push_Topicplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez le nom du sujet (ex. : mises-a-jour)`)
};

const it_notifications_push_topicplaceholder1 = /** @type {(inputs: Notifications_Push_Topicplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci il nome dell'argomento (es., game-updates)`)
};

const hu_notifications_push_topicplaceholder1 = /** @type {(inputs: Notifications_Push_Topicplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add meg a téma nevét (pl. game-updates)`)
};

const nl_notifications_push_topicplaceholder1 = /** @type {(inputs: Notifications_Push_Topicplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer onderwerpnaam in (bijv. game-updates)`)
};

const no_notifications_push_topicplaceholder1 = /** @type {(inputs: Notifications_Push_Topicplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skriv inn emnenavn (f.eks. game-updates)`)
};

const pl_notifications_push_topicplaceholder1 = /** @type {(inputs: Notifications_Push_Topicplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wprowadź nazwę tematu (np. aktualizacje-gier)`)
};

const pt_br2_notifications_push_topicplaceholder1 = /** @type {(inputs: Notifications_Push_Topicplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter topic name (e.g., game-updates)`)
};

const pt_notifications_push_topicplaceholder1 = /** @type {(inputs: Notifications_Push_Topicplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insira o nome do tópico (ex., atualizações-jogo)`)
};

const ro_notifications_push_topicplaceholder1 = /** @type {(inputs: Notifications_Push_Topicplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introdu numele subiectului (ex., actualizări-jocuri)`)
};

const fi_notifications_push_topicplaceholder1 = /** @type {(inputs: Notifications_Push_Topicplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syötä aiheen nimi (esim. peli-päivitykset)`)
};

const sv_notifications_push_topicplaceholder1 = /** @type {(inputs: Notifications_Push_Topicplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ange ämnesnamn (t.ex., spel-uppdateringar)`)
};

const vi_notifications_push_topicplaceholder1 = /** @type {(inputs: Notifications_Push_Topicplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập tên chủ đề (ví dụ: game-updates)`)
};

const tr_notifications_push_topicplaceholder1 = /** @type {(inputs: Notifications_Push_Topicplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konu adını girin (örn. oyun-guncellemeleri)`)
};

const cs_notifications_push_topicplaceholder1 = /** @type {(inputs: Notifications_Push_Topicplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zadejte název tématu (např. herni-aktualizace)`)
};

const bg_notifications_push_topicplaceholder1 = /** @type {(inputs: Notifications_Push_Topicplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Въведете име на тема (напр. game-updates)`)
};

const ru_notifications_push_topicplaceholder1 = /** @type {(inputs: Notifications_Push_Topicplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите название темы (например, game-updates)`)
};

const uk_notifications_push_topicplaceholder1 = /** @type {(inputs: Notifications_Push_Topicplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введіть назву теми (напр., game-updates)`)
};

const ar_notifications_push_topicplaceholder1 = /** @type {(inputs: Notifications_Push_Topicplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أدخل اسم الموضوع (مثال: game-updates)`)
};

const hi_notifications_push_topicplaceholder1 = /** @type {(inputs: Notifications_Push_Topicplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विषय नाम दर्ज करें`)
};

const th_notifications_push_topicplaceholder1 = /** @type {(inputs: Notifications_Push_Topicplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ป้อนชื่อหัวข้อ (เช่น game-updates)`)
};

const ja_notifications_push_topicplaceholder1 = /** @type {(inputs: Notifications_Push_Topicplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トピック名を入力（例：game-updates）`)
};

const zh_cn2_notifications_push_topicplaceholder1 = /** @type {(inputs: Notifications_Push_Topicplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter topic name (e.g., game-updates)`)
};

const zh_hant1_notifications_push_topicplaceholder1 = /** @type {(inputs: Notifications_Push_Topicplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter topic name (e.g., game-updates)`)
};

const ko_notifications_push_topicplaceholder1 = /** @type {(inputs: Notifications_Push_Topicplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주제 이름 입력 (예: game-updates)`)
};

/**
* | output |
* | --- |
* | "Enter topic name (e.g., game-updates)" |
*
* @param {Notifications_Push_Topicplaceholder1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_push_topicplaceholder1 = /** @type {((inputs?: Notifications_Push_Topicplaceholder1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Push_Topicplaceholder1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_push_topicplaceholder1(inputs)
	if (locale === "ms") return ms_notifications_push_topicplaceholder1(inputs)
	if (locale === "da") return da_notifications_push_topicplaceholder1(inputs)
	if (locale === "de") return de_notifications_push_topicplaceholder1(inputs)
	if (locale === "en-US") return en_us2_notifications_push_topicplaceholder1(inputs)
	if (locale === "es-ES") return es_es2_notifications_push_topicplaceholder1(inputs)
	if (locale === "es-MX") return es_mx2_notifications_push_topicplaceholder1(inputs)
	if (locale === "fil") return fil_notifications_push_topicplaceholder1(inputs)
	if (locale === "fr") return fr_notifications_push_topicplaceholder1(inputs)
	if (locale === "it") return it_notifications_push_topicplaceholder1(inputs)
	if (locale === "hu") return hu_notifications_push_topicplaceholder1(inputs)
	if (locale === "nl") return nl_notifications_push_topicplaceholder1(inputs)
	if (locale === "no") return no_notifications_push_topicplaceholder1(inputs)
	if (locale === "pl") return pl_notifications_push_topicplaceholder1(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_push_topicplaceholder1(inputs)
	if (locale === "pt") return pt_notifications_push_topicplaceholder1(inputs)
	if (locale === "ro") return ro_notifications_push_topicplaceholder1(inputs)
	if (locale === "fi") return fi_notifications_push_topicplaceholder1(inputs)
	if (locale === "sv") return sv_notifications_push_topicplaceholder1(inputs)
	if (locale === "vi") return vi_notifications_push_topicplaceholder1(inputs)
	if (locale === "tr") return tr_notifications_push_topicplaceholder1(inputs)
	if (locale === "cs") return cs_notifications_push_topicplaceholder1(inputs)
	if (locale === "bg") return bg_notifications_push_topicplaceholder1(inputs)
	if (locale === "ru") return ru_notifications_push_topicplaceholder1(inputs)
	if (locale === "uk") return uk_notifications_push_topicplaceholder1(inputs)
	if (locale === "ar") return ar_notifications_push_topicplaceholder1(inputs)
	if (locale === "hi") return hi_notifications_push_topicplaceholder1(inputs)
	if (locale === "th") return th_notifications_push_topicplaceholder1(inputs)
	if (locale === "ja") return ja_notifications_push_topicplaceholder1(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_push_topicplaceholder1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_push_topicplaceholder1(inputs)
	return ko_notifications_push_topicplaceholder1(inputs)
});
export { notifications_push_topicplaceholder1 as "notifications.push.topicPlaceholder" }